import { css } from 'aphrodite/no-important';
import React from 'react';
import { Paragraph } from '@trainline/depot-web';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

import { useFetchJourney } from '@contactcentre-web/hooks/api/useFetchJourney';

import messages from '../../messages';

import styles from './styles';
import { TrackingBoundariesWrapper } from './TrackingBoundariesWrapper';
import { JourneyLeg } from './JourneyLeg';

export const JourneyTrackCard = () => {
  const { journey } = useFetchJourney();

  const timeDifferenceHours =
    journey?.trackingStoppedDateTime &&
    dayjs(journey.trackingStoppedDateTime).diff(journey.trackingStartedDateTime, 'hours');

  const timeDifferenceMinutes =
    journey?.trackingStoppedDateTime &&
    dayjs(journey.trackingStoppedDateTime).diff(journey.trackingStartedDateTime, 'minutes') % 60;

  return (
    <div className={css(styles.journeyTrackCard)}>
      <TrackingBoundariesWrapper
        startTime={journey.trackingStoppedDateTime}
        endTime={journey.trackingStoppedDateTime}
      >
        {journey.sourceDetails.verifiedJourneyMetadata.legs.map(
          ({
            timetableId,
            originStationName,
            scheduledDepartureDateTime,
            actualDepartureDateTime,
            destinationStationName,
            scheduledArrivalDateTime,
            actualArrivalDateTime,
          }) => (
            <JourneyLeg
              key={timetableId}
              originStationName={originStationName}
              departureDateTime={(actualDepartureDateTime || scheduledDepartureDateTime)!}
              destinationStationName={destinationStationName!}
              arrivalDateTime={(actualArrivalDateTime || scheduledArrivalDateTime)!}
            />
          )
        )}
      </TrackingBoundariesWrapper>
      <div className={css(styles.supplementaryText)}>
        <Paragraph color="subdued">
          <FormattedMessage {...messages.totalTrackedTime} />:{' '}
          {timeDifferenceHours ? `${timeDifferenceHours}h` : ''}
          {timeDifferenceHours ? timeDifferenceMinutes && ' ' : ''}
          {timeDifferenceMinutes && `${timeDifferenceMinutes}m`}
        </Paragraph>
        {journey.sourceDetails.verifiedJourneyMetadata.distanceTravelled && (
          <>
            <Paragraph color="subdued">•</Paragraph>
            <Paragraph color="subdued">
              <FormattedMessage {...messages.distance} />:{' '}
              {journey.sourceDetails.verifiedJourneyMetadata.distanceTravelled}
            </Paragraph>
          </>
        )}
      </div>
    </div>
  );
};
